import { createGenericDispatcher } from '../action-dispatcher-factory';

import * as Api from '../../api/api';

export const createVCard = (orgId: number) =>
  createGenericDispatcher({
    name: 'CREATE_V_CARD',
    loadFunction: () => Api.post(`/org/${orgId}/create-v-Card`),
    args: { orgId },
  });
